import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'b3';
import { updateCallData, goToNextAction, noAnswerSelected } from '../logActivityReducer';
import { EVALUATION_CLIENT_STAGE_ID } from '../../../constants/clientStages';
import EvaluateClient from './EvaluateClient';
import ScheduleNextOrComplete from './ScheduleNextOrComplete';

var goNext = (client, goToNextAction) => {
	client.clientStageId == EVALUATION_CLIENT_STAGE_ID ? 
		goToNextAction(EvaluateClient) : 
		goToNextAction(ScheduleNextOrComplete);
}

var CallAnswered = ({goToNextAction, updateCallData, client, disabled, noAnswerSelected}) => (
	<div className="wizardStepActions">
		<div className="header">
			<h2>Did the call go through?</h2>
		</div>
		<div className="buttonsRow">
			<Button disabled={disabled} onClick={e => {
				updateCallData({answered: true});
				goNext(client, goToNextAction);
			}} type="success">Answered</Button>
			<Button disabled={disabled} onClick={e => {
				updateCallData({leftMessage: true});
				goToNextAction(ScheduleNextOrComplete);
			}} style={{marginLeft: 20, marginRight: 20}} type="warning">Left a Message</Button>
			<Button disabled={disabled} onClick={noAnswerSelected} type="danger">No Answer</Button>
		</div>
	</div>
);

export default connect(
	state => ({
		client: state.activeClient.client,
		disabled: ! state.logActivityWizard.callData.participatingContactId
	}),
	{ updateCallData, goToNextAction, noAnswerSelected }
)(CallAnswered);


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/actions/CallAnswered.js